import React from 'react';
import { Box, Text, VStack, Button, Badge } from '@chakra-ui/react';

const AlphaQuantBotPanel: React.FC = () => {
  console.log("🚀🚀🚀 ALPHA BOT COMPONENT IS LOADING!!! 🚀🚀🚀"); // Debug log
  
  return (
    <VStack spacing={6} p={8} bg="red.500" borderRadius="lg" border="5px solid yellow" minH="400px">
      <Badge colorScheme="green" fontSize="2xl" p={3}>
        ⚡ ALPHA BOT ACTIVE ⚡
      </Badge>
      <Text fontSize="4xl" fontWeight="bold" color="white" textAlign="center">
        🚀🤖 ALPHA BOT IS HERE!!! 🤖🚀
      </Text>
      <Text fontSize="xl" color="yellow.200" textAlign="center">
        SUCCESS! Alpha Bot integration is working in Alpha Playbook!
      </Text>
      <Button colorScheme="yellow" size="lg" fontSize="xl" p={6}>
        🎯 ALPHA BOT READY 🎯
      </Button>
      <Text fontSize="lg" color="white" textAlign="center">
        This is the main Alpha Playbook platform with Alpha Bot integrated!
      </Text>
    </VStack>
  );
};

export default AlphaQuantBotPanel;